import { Layout } from '~/components/Layout'
import type { LoaderFunction, MetaFunction } from '@remix-run/node'
import TitleSection from '~/components/press/TitleSection'
import ArticleContent from '~/components/press/ArticleContent'
import { CIOEntries } from '~/libs/contentful/types/entries'
import ContentfulClientManager from '../libs/contentful/ContentfulClientManager'
import {
  TypePagePressPageLandingSkeleton,
  TypePressReleaseArticlesSkeleton,
} from '~/types/contentful'

export const loader: LoaderFunction = async ({ params }) => {
  const { slug: pageUrl } = params
  const entries =
    await ContentfulClientManager.getContentfulEntries<TypePagePressPageLandingSkeleton>(
      CIOEntries.press,
      {
        include: 3,
      },
    )
  const articleData =
    await ContentfulClientManager.getContentfulEntries<TypePressReleaseArticlesSkeleton>(
      CIOEntries.pressReleaseArticles,
      {
        include: 1,
        'fields.pageUrl': pageUrl,
      },
    )
  if (articleData?.items?.length === 0) {
    throw new Error('Article not found')
  }
  return {
    pressPage: entries?.items[0],
    articleData: articleData?.items[0],
  }
}

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  const { articleData } = data || {}

  return [
    {
      title: articleData?.metaTitle,
    },
    { name: 'description', content: articleData?.metaDescription },
  ]
}

export default function Article() {
  return (
    <Layout>
      <TitleSection type={'article'} />
      <Layout.Content
        style={{ padding: 0, paddingTop: '100px', display: 'flex', flexDirection: 'column' }}
      >
        <ArticleContent />
      </Layout.Content>
    </Layout>
  )
}
